import { ctx } from '@/util/context'
import { logWarn, LruCache } from '@amzn/vinyl-util'
import { playParamsFrag } from '@/service/fragments/playParamsFrag'
import { graphql } from '@/service/graphql'
import type { ArtistFields } from '@/artist/artistFieldsFrag'
import type { TrackFields } from '@/track/trackFieldsFrag'
import type { PlaylistFields } from '@/playlistdetail/playlistFieldsFrag'
import type { StationFields } from '@/service/fragments/stationFieldsFrag'
import type { PodcastEpisodeFields } from '@/podcast/podcastEpisodeFieldsFrag'
import type { PodcastShowFields } from '@/podcast/podcastShowFieldsFrag'
import type { AlbumFields } from '@/album/albumFieldsFrag'

export type PlayableEntity =
    | ArtistFields
    | AlbumFields
    | TrackFields
    | PlaylistFields
    | StationFields
    | PodcastEpisodeFields
    | PodcastShowFields

// TODO: add 'Advertisement' | 'Audiobook' | 'Interlude'

// language=GraphQL
export const playableEntityFrag = graphql(
    `
        fragment playableEntity on PlayableEntity @_unmask {
            __typename
            uri @include(if: $isAuthenticated)
            playParams {
                ...playParams
            }
        }
    `,
    [playParamsFrag]
)

const { target } = ctx('PlayableEntity')
const entityCache = new LruCache<string, PlayableEntity>(20)

export function getCachedEntity(id: string): PlayableEntity | null {
    return entityCache.get(id) ?? null
}

export function cacheEntity(entity: PlayableEntity) {
    if (!entity.id) {
        logWarn(target, 'entity.id nullish')
        return
    }
    entityCache.set(entity.id, entity)
}
